import React, { useState } from 'react';
import { motion } from 'framer-motion';
// eslint-disable-next-line
import ProductSlider from './ProductSlider';

export default function Contact({ onProductInquiry }) {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    address: '',
    message: '',
  });

  React.useEffect(() => {
    if (onProductInquiry) {
      onProductInquiry((finalMessage) => {
        setFormData((prev) => ({
          ...prev,
          message: finalMessage,
        }));

        // Optional: scroll to contact section smoothly
        document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
      });
    }
  }, [onProductInquiry]);
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const formItemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  // --- IMPORTANT: This is now YOUR PYTHON BACKEND URL ---
  const BACKEND_SUBMISSION_URL = "https://a3creativehub.in/api/app/submit-form";
  // --- END IMPORTANT SECTION ---

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus('submitting');

    try {
      const response = await fetch(BACKEND_SUBMISSION_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Send JSON to your Python backend
        },
        body: JSON.stringify(formData), // Stringify your formData object
      });

      // Your Python backend will return JSON, so you can parse it
      const result = await response.json();
      console.log("Response from Python backend:", result);

      if (result.status === 'success') {
        setSubmissionStatus('success');
        setFormData({ name: '', mobile: '', email: '', address: '', message: '' });
      } else {
        setSubmissionStatus('error');
        console.error('Backend reported an error:', result.message);
      }
    } catch (error) {
      console.error('Error connecting to backend:', error);
      setSubmissionStatus('error');
    }
  };

  return (
    <section id="contact" className="pt-16 py-16 bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 md:py-12 md:px-10 scroll-mt-16">
      <motion.h3
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.5 }}
        variants={formItemVariants}
        className="text-3xl text-center font-bold text-pink-600 mb-6"
      >
        Let's Connect
      </motion.h3>
      <motion.form
        onSubmit={handleSubmit}
        className="max-w-xl mx-auto bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 p-8 rounded-xl shadow-lg space-y-6"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.5 }}
      >
        <motion.input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400 transition"
          variants={formItemVariants}
        />
        <motion.input
          type="number"
          name="mobile"
          placeholder="Mobile Number"
          value={formData.mobile}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400 transition"
          variants={formItemVariants}
        />
        <motion.input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400 transition"
          variants={formItemVariants}
        />
        <motion.textarea
          name="address"
          placeholder="Enter your address"
          value={formData.address}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400 transition"
          variants={formItemVariants}
        ></motion.textarea>
        <motion.textarea
          name="message"
          placeholder="Your detailed message here. Eg., Product name, No. of quantity, delivery date, function name (marriage, birthday party and so on)"
          rows="4"
          value={formData.message}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-pink-400 transition"
          variants={formItemVariants}
        ></motion.textarea>

        <motion.button
          type="submit"
          className="bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 text-blue-700 font-bold py-3 px-6 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full"
          variants={formItemVariants}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          disabled={submissionStatus === 'submitting'}
        >
          {submissionStatus === 'submitting' ? 'Sending...' : 'Send Message'}
        </motion.button>

        {submissionStatus === 'success' && (
          <p className="text-center text-green-600 mt-4">Thank you for contacting us. Our team will call you within <strong>24 hours</strong> to confirm your order.<br /><strong>Happy Ordering!!!</strong></p>
        )}
        {submissionStatus === 'error' && (
          <p className="text-center text-red-600 mt-4">Unexpected error occurred.<br /> Please try again.</p>
        )}
      </motion.form>
    </section>
  );
}